import {
    faBook,
    faBracketsCurly,
    faBullhorn,
    faCalculator,
    faClock,
    faCode,
    faCogs,
    faEdit,
    faFileDoc,
    faFilter,
    faLock,
    faPuzzlePiece,
    faRectangleList,
    faRocketLaunch,
    faSearch,
    faShop,
    faShuffle,
    faSlidersH,
    faSquarePlus,
    faStar,
    faUser,
    faGauge,
    faPhone,
    faInputText,
    faEquals,
    faNotEqual,
    faCalculatorSimple,
    faArrowsRotate,
    faChartScatter,
    faSigma,
    faCalendar,
    faEnvelope,
    faHouse
} from "@fortawesome/sharp-solid-svg-icons";

export function getIcon(icon) {
    const iconMap = {
        "arrows-rotate": faArrowsRotate,
        "book": faBook,
        "brackets-curly": faBracketsCurly,
        "bullhorn": faBullhorn,
        "calculator": faCalculator,
        "calculator-simple": faCalculatorSimple,
        "calendar": faCalendar,
        "chart-scatter": faChartScatter,
        "clock": faClock,
        "code": faCode,
        "cogs": faCogs,
        "edit": faEdit,
        "envelope": faEnvelope,
        "equal": faEquals,
        "filter": faFilter,
        "gauge": faGauge,
        "input-text": faInputText,
        "lock": faLock,
        "not-equal": faNotEqual,
        "phone": faPhone,
        "puzzle-piece": faPuzzlePiece,
        "rectangle-list": faRectangleList,
        "rocket": faRocketLaunch,
        "search": faSearch,
        "shop": faShop,
        "shuffle": faShuffle,
        "sigma": faSigma,
        "sliders": faSlidersH,
        "square-plus": faSquarePlus,
        "star": faStar,
        "user": faUser,
        "house": faHouse
    };

    return iconMap[icon] || faFileDoc;
}